import React, { Suspense } from "react";
import { observer } from "mobx-react";
import { IconButton } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

import Icon from "../Icon";
import { setWebBridge } from "../../utils/webBridge";
import HideOnScroll, { Props as HideOnScrollProps } from "./HideOnScroll";
import { MuiAppBar, MuiToolBar } from "./style";
import { LoadingPanel } from "..";
import { firebaseEvent, screenType } from "../../utils/firebaseEvent";

export interface Props extends HideOnScrollProps {
  isTopMargin?: boolean;
  headerProps?: {
    isZIndexTop?: boolean;
    isTransparent?: boolean;
    children: React.ReactElement;
  };
}

function Layout(props: Props) {
  const { headerProps } = props;
  // kmwd-360 수정으로 인한 제거
  // const TopMargin = () => {
  //   if (!isTopMargin) return null;
  //   return <div style={{ height: 56 }} />;
  // };

  const Header = () => {
    if (!headerProps) return null;

    const {
      children,
      isTransparent = false,
      isZIndexTop = false,
    } = headerProps;
    const backgroundColor = isTransparent ? "transparent" : "#1f2126";
    const appBarZIndex = isZIndexTop ? zIndex.modal : zIndex.appBar;
    const hideOnScrollProps = {
      children: props.children,
      isHideOnScroll: props.isHideOnScroll,
    };

    const CloseButton = () => {
      const onClick = () => {
        //Firebase Event
        const jsonParams = {
          P1: screenType(),
          P2: window.location.pathname,
        };
        firebaseEvent("close", jsonParams);
        const videoRef = document.getElementsByTagName("video")[0];
        // video tag가 있으면 video 실행 멈춤
        if (videoRef) videoRef.pause();

        setWebBridge({
          name: "onWebClose",
        });
      };
      return (
        <IconButton onClick={onClick}>
          <Icon name="close" size={28} />
        </IconButton>
      );
    };

    return (
      <HideOnScroll {...hideOnScrollProps}>
        <MuiAppBar
          variant="outlined"
          background_color={backgroundColor}
          z_index={appBarZIndex}
        >
          <MuiToolBar>
            {children}
            <CloseButton />
          </MuiToolBar>
        </MuiAppBar>
      </HideOnScroll>
    );
  };

  return (
    <Suspense fallback={<LoadingPanel isOpen backdropInvisible />}>
      {/* <TopMargin /> */}
      <Header />
      {props.children}
    </Suspense>
  );
}

export default observer(Layout);
